var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.344 13.312h-9.596l6.391 6.482a.642.642 0 00.897.028 9.864 9.864 0 002.958-5.777.655.655 0 00-.65-.733zm-.64-2.657c-.333-4.9-4.193-8.816-9.025-9.154-.368-.025-.679.29-.679.665v9.178h9.05c.37 0 .68-.315.654-.69zM10.06 13.312V3.58c0-.392-.34-.714-.722-.659C4.518 3.611.834 7.881 1.006 13c.176 5.255 4.638 9.565 9.822 9.5a9.546 9.546 0 005.47-1.807c.32-.23.341-.706.064-.987l-6.303-6.394z"
  }))));
}

export default SvgChartPie;